@if (item) {
<planone-item-teaser-card
  [url]="['/fairs', fairId, 'products', item.id]"
  [showSubtitleArea]="pageContext === 'search' || pageContext === 'newsfeed'"
  [imageUrl]="
    displayImage?.resource
      | ImageUrl : displayImage?.provider : { width: 396, height: 192, fileType: ImageFileTypes.WEBP }
  "
  imagePlaceholderIcon="package_2"
  [highlight]="item.is_highlighted && (pageContext === 'search' || pageContext === 'newsfeed')"
  [cardTitle]="item.name"
  [markAsNew]="markAsNew">
  <ng-container card-subtitle>
    <span class="mat-caption subtitle__caption" i18n="@@featureProduct-card-caption">Produkt</span>
  </ng-container>
  <ng-container card-content>
    <planone-icon-text icon="corporate_fare" [displayLines]="2">
      <span class="content__text">{{ exhibitor?.display_name ?? exhibitor?.name }}</span>
    </planone-icon-text>
    @if (exhibitor && exhibitor.address) {
    <planone-icon-text icon="location_on">
      <planone-address [address]="exhibitor.address" [format]="['city', 'country']"></planone-address>
    </planone-icon-text>
    }
  </ng-container>
  <ng-container card-actions>
    <button class="action mat-icon-button" color="primary" (click)="openShareButtonDialog($event)">
      <mat-icon class="action__icon">share</mat-icon>
    </button>
    <bau365-toggle-watchlist-item
      class="action"
      [entityId]="item.id"
      [entityType]="EntityType.product"
      [pageContext]="pageContext"
      [fairId]="item.fair_id"></bau365-toggle-watchlist-item>
  </ng-container>
</planone-item-teaser-card>
}
<ng-template #shareButtonsTitle>
  <span i18n="@@featureProduct-card-shareDialog-title">Teilen</span>
</ng-template>
<ng-template #shareButtons>
  <planone-share-buttons
    [url]="url"
    [disabledProvider]="['print']"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareButtonClicked)="shareButtonClick($event)"></planone-share-buttons>
</ng-template>
